export default "__VITE_ASSET__CZdokBym__"